import { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import usePermissions from '@hooks/usePermissions';
import { RoutePath } from '@constants/routes';
import { childRoutePath } from '@helpers/navigation';
import PageContainer from '@components/Layout/PageContainer';
import KnowledgeBase from './KnowledgeBase';
import Agents from './Agents';

const PageWrapper = styled(PageContainer)({
    '@media (max-width: 1024px)': {
        padding: '16px 16px 0',
    },
});

const PulseAI = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();
    const { hasFullAccess } = usePermissions();
    const canManageContent = hasFullAccess('messaging');

    if (!canManageContent) {
        return <Navigate to={RoutePath.MessagingInbox} replace />;
    }

    const availableTabs = [
        { label: t('Sidebar.agents'), value: RoutePath.MessagingPulseAIAgents },
        { label: t('Sidebar.knowledgeBase'), value: RoutePath.MessagingPulseAIKnowledgeBase },
    ];

    const RouteMap = {
        [RoutePath.MessagingPulseAIAgents]: 0,
        [RoutePath.MessagingPulseAIKnowledgeBase]: 1,
    };

    return (
        <PageWrapper>
            <NavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Routes>
                <Route
                    path={childRoutePath(RoutePath.MessagingPulseAIKnowledgeBase, RoutePath.MessagingPulseAI)}
                    element={<KnowledgeBase />}
                />
                <Route
                    path={childRoutePath(RoutePath.MessagingPulseAIAgents, RoutePath.MessagingPulseAI)}
                    element={<Agents />}
                />
                <Route path="*" element={<Navigate to={RoutePath.MessagingPulseAIAgents} replace />} />
            </Routes>
        </PageWrapper>
    );
};

export default PulseAI;
